import { ReactNode } from "react";
import Skeleton from "react-loading-skeleton";
import { ModalComponent } from "..";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../../utils/constants";
import { Icon } from "../../icons/icon";

export const MoreDetailsModal = ({
  modalOpen,
  onModalClose = () => {},
  mainData = {},
  title = "",
  extraInfoTitle = "",
  secondaryData = {},
  loading = false,
}: {
  modalOpen: boolean;
  onModalClose: () => void;
  mainData: Record<string, ReactNode>;
  title: string;
  extraInfoTitle: string;
  secondaryData: Record<string, ReactNode>;
  loading?: boolean;
}) => {
  return (
    <ModalComponent
      isModalOpen={modalOpen}
      onModalClose={onModalClose}
      showHeader={false}
      title={title}
      topTitle
      subTitle={undefined}
      childrenClassName="md:!mt-0"
      modalClassName="md:!max-w-[792px] !overflow-y-scroll !pb-0 !pr-0 !pl-0 md:!pt-0"
      hasButtons={false}
      closeOnOutsideClick
    >
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="bg-white px-6 lg:pl-10 md:py-10 flex flex-col gap-6">
          <p className="font-bold text-pry-dark-green-400 text-lg">{title}</p>

          <div className="flex flex-col">
            {mainData &&
              Object.keys(mainData)?.map((val, idx) => {
                const key = `${val}-${idx}`;
                return (
                  <div
                    key={key}
                    className={`flex justify-between py-3 border-b first:pt-0 last:border-b-0 text-xs`}
                  >
                    <p className={`font-medium text-pry-dark-green-300/80 `}>
                      {val}:
                    </p>

                    {loading ? (
                      <Skeleton
                        baseColor={SKELETON_BASE_COLOR}
                        highlightColor={SKELETON_HIGHLIGHT_COLOR}
                        height={16}
                        width={"100%"}
                        containerClassName="!h-fit w-6/12 pt-0"
                        className="opacity-50"
                      />
                    ) : (
                      <div className="text-pry-dark-green-300/70">
                        {mainData[val]}
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>

        <div className="!bg-light-green-bg px-6 lg:pr-10 py-6 md:py-10 flex flex-col gap-6">
          <button
            className="w-fit ml-auto max-md:hidden"
            onClick={() => {
              onModalClose();
            }}
          >
            <Icon svg="close-icon" width={24} height={24} />
          </button>

          <div className="flex flex-col gap-3">
            <p className="text-base font-medium mb-2">{extraInfoTitle}</p>

            {secondaryData &&
              Object.keys(secondaryData)?.map((val, idx) => {
                const key = `${val}-${idx}`;
                return (
                  <div
                    key={key}
                    className={`flex justify-between pb-3 text-xs`}
                  >
                    <p className={`font-medium text-pry-dark-green-300/80 `}>
                      {val}:
                    </p>

                    {loading ? (
                      <Skeleton
                        baseColor={SKELETON_BASE_COLOR}
                        highlightColor={SKELETON_HIGHLIGHT_COLOR}
                        height={16}
                        width={"100%"}
                        containerClassName="!h-fit w-6/12 pt-0"
                        className="opacity-50"
                      />
                    ) : (
                      <div className="text-pry-dark-green-300/70">
                        {secondaryData[val]}
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};
